export { Tooltip } from './Tooltip';
export type { TooltipProps, TooltipVariant } from './Tooltip';
